<div class="accordion"
     [ngClass]="{
       'accordion-bordered': bordered,
       'accordion-no-gutter': noGutter,
       'accordion-start-indicator': startIndicator,
       'accordion-with-icon': withIcon,
       'accordion-header-bg': headerBg,
       'accordion-solid-bg': solidBg,
       'accordion-active-header': activeHeader,
       'accordion-header-shadow': headerShadow,
       'accordion-rounded': rounded,
       'accordion-rounded-stylish': roundedStylish,
       'accordion-gradient': gradient
     }"
     id="accordion-one">
  <div class="accordion-item" *ngFor="let item of accordionItems; let i = index">
    <button   class="accordion-header rounded-lg"
  [class.collapsed]="i !== 0"
  [attr.id]="'heading'+i"
  data-bs-toggle="collapse"
  [attr.data-bs-target]="'#collapse'+i"
  [attr.aria-controls]="'collapse'+i"
  [attr.aria-expanded]="i === 0 ? 'true' : 'false'"
  type="button">
      <span class="accordion-header-icon"></span>
      <span class="accordion-header-text">{{ item.header }}</span>
      <span class="accordion-header-indicator"></span>
    </button>
    <div [id]="'collapse'+i"
         class="collapse"
         [class.show]="i === 0"
         [attr.aria-labelledby]="'heading'+i"
         data-bs-parent="#accordion-one">
      <div class="accordion-body-text">
        {{ item.content }}
      </div>
    </div>
  </div>
</div>
